<template>
  <div class="c-app flex-row align-items-center">
    <CContainer class="col-md-7">
      <CRow class="justify-content-center">
        <CCol col="8">
          <CCardGroup>
            <CCard class="p-4" v-if="show_email_login || !IS_MZ_BRANDING">
              <CCardBody>
                <CForm @submit.prevent="handleLogin">
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <CInput
                      placeholder="Username"
                      autocomplete="username email"
                      v-model="login"
                      name="login"
                      class="mb-2"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-user"/>
                    </template>
                  </CInput>
                  <CInput
                      placeholder="Password"
                      type="password"
                      autocomplete="current-password"
                      v-model="password"
                      name="password"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-lock-locked"/>
                    </template>
                  </CInput>
                  <CRow class="mt-2">
                    <CCol col="6" class="text-left">
                      <CButton
                        color="primary"
                        class="px-4"
                        type="submit"
                        data-cy=login-button
                        :disabled="!captcha"
                      >Login</CButton>
                    </CCol>
                    <CCol col="6" class="text-right">
                      <CButton
                          color="link"
                          class="px-0"
                          to="/account/forgot"
                          data-cy="forgot-password-link"
                      >
                        Forgot password?
                      </CButton>
                    </CCol>
                  </CRow>
                  <div class="d-flex justify-content-end mt-2">
                    <vue-recaptcha
                      class="mt-3"
                      @verify="handleCaptcha"
                      @expired="captcha = null"
                      loadRecaptchaScript
                      data-cy="captcha"
                      :sitekey="CAPTCHA_KEY"
                    />
                  </div>
                </CForm>
              </CCardBody>
            </CCard>
            <CCard
                v-else
                color="primary"
                text-color="white"
                class="text-center py-5"
                body-wrapper
            >
              <CCardBody>
                <div class="login-left">
                  <form action="." method="post" class="flex-2">
                    <div class="center-box">
                      <div>
                        <h2>Login</h2>
                        <p class="text-muted">Login to your Mazars account</p>
                        <div class="card-body">
                          <a :href="mzAuthUri" class="btn btn-lg btn-secondary px-4 text-center">
                            <div v-if="oauthLoading">
                              <CSpinner/>
                            </div>

                            <div v-else>
                              <img src='/img/logo-galileo-color-2x.png' alt='' class='img-responsive' style='max-width: 100px'>
                              <div>
                                Sign in via
                                <br>
                                Mazars The Gate™
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
    <LoginRight/>
  </div>
</template>

<script>
import { request } from '@/utils/request';
import { API_ENDPOINTS } from '@/constants/common';
import { getSearchParam } from '@/utils/helpers';
import { ActiveUser } from '@/services/user';
import { IS_MZ_BRANDING, CAPTCHA_KEY } from '@/constants/config';
import { AuthService } from '@/services/auth';
import LoginRight from '@/components/LoginRight';
import VueRecaptcha from 'vue-recaptcha';

export default {
  name: 'Login',
  components: { LoginRight, VueRecaptcha },
  props: ['show_email_login'],
  data: function () {
    return {
      IS_MZ_BRANDING,
      CAPTCHA_KEY,
      login: '',
      password: '',
      mzAuthUri: '',
      oauthLoading: false,
      captcha: null,
    };
  },
  mounted() {
    this.redirectAuthenticated();
    this.tryLoginWithAccessCode();
    if (IS_MZ_BRANDING) {
      this.fetchMzAuthUri();
    }
  },
  methods: {
    redirectAfterLogin() {
      const pathToLoadAfterLogin = localStorage.getItem('pathToLoadAfterLogin');
      localStorage.removeItem('pathToLoadAfterLogin');
      this.$router.replace((!pathToLoadAfterLogin?.includes("login") && pathToLoadAfterLogin) || '/');
    },
    handleCaptcha(res) {
      this.captcha = res
    },
    redirectAuthenticated() {
      if (ActiveUser.get()) this.redirectAfterLogin()
    },
    async tryLoginWithAccessCode() {
      const code = getSearchParam('code');
      const state = getSearchParam('state');
      if (code && state) {
        this.oauthLoading = true;
        const { data } = await request({
          url: API_ENDPOINTS.mzAuthCallback,
          query: {
            code,
            state,
          },
        });
        const { access_token } = data;
        ActiveUser.setToken(access_token);
        this.redirectAfterLogin()
      }
    },
    async fetchMzAuthUri() {
      const { data } = await request({
        url: API_ENDPOINTS.mzAuth,
      });
      const { authorization_url } = data;
      this.mzAuthUri = authorization_url;
    },
    async handleLogin() {
      const { res } = await AuthService.login({
        email: this.login,
        password: this.password,
        captcha: this.captcha,
      });
      if (res.status !== 200) {
        return alert('Login failed');
      }
      this.redirectAuthenticated();
    },
  },
};
</script>

<style scoped lang="scss">
.hidden-input {
  display: none;
}
</style>
